<template lang="pug" src="./html/ChinaDigitalOverview-Body.pug"></template>

<script>
  import ArticleItemBase from './ArticleItemBase'

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setupVideo('267018667', 'https://player.youku.com/embed/XNDAxNDU2NTk5Mg==')
    }
  }
</script>
